// test1995
(1995 && 0);
